import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { selectCompany } from "../../homeSlice";
import {
  selectVehicleSessionsListStatus,
  vehicleSessionsAsync,
} from "../fleetSlice";
import { SharedInterfaceVehicleSessions } from "./sharedInterface";

export const VehicleSessionsTab = () => {
  const params = useParams();
  const dispatch = useAppDispatch();
  const company = useAppSelector(selectCompany);
  const vehicleSessionsListStatus = useAppSelector(
    selectVehicleSessionsListStatus,
  );

  useEffect(() => {
    if (company && vehicleSessionsListStatus === "idle") {
      void dispatch(vehicleSessionsAsync(company.uuid));
    }
  }, [company, dispatch, vehicleSessionsListStatus]);

  if (params.tab !== "vehicle_sessions") {
    return;
  }

  return <SharedInterfaceVehicleSessions />;
};
